<template>
  <v-slide-x-transition>
    <v-list-tile v-if="feature && items.length" class="my-3">
      <v-combobox
        v-model="model"
        clearable
        hide-details
        :items="featureValues"
        label="Mapear como"
        :loading="loadingFeatureValues"
        open-on-clear
        prepend-icon="near_me"
      />
    </v-list-tile>
  </v-slide-x-transition>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", [
      "feature",
      "featureValue",
      "featureValues",
      "items",
      "loadingFeatureValues"
    ]),
    model: {
      get() {
        return this.featureValue;
      },
      set(value) {
        this.setFeatureValue(value);
      }
    }
  },
  methods: {
    ...mapMutations("featureRules", ["setFeatureValue"])
  }
};
</script>
